import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DdlSearchHeaderComponent } from './ddl-search-header.component';
import { TranslateModule } from '@ngx-translate/core';
import { SvgModule } from '../svg/svg.module';
import { DirectivesModule } from '../directives/directives.module';
import { TranslationModule } from 'src/app/i18n/translation.module';


@NgModule({
  declarations: [
    DdlSearchHeaderComponent
  ],
  imports: [
    CommonModule,
    SvgModule,
    TranslateModule,
    DirectivesModule,
    TranslationModule
  ],
  exports:[DdlSearchHeaderComponent]
})
export class DdlSearchHeaderModule { }
